/* eslint-disable no-unused-vars */
import {
  takeLatest, all, call, select, takeEvery, put,
} from 'redux-saga/effects';
import {
  addResponseMessage,
  toggleMsgLoader,
  renderCustomComponent,
  setQuickButtons,
} from 'react-chat-widget-t';
import _ from 'lodash';

import {
  WEBWIDGET_SEND_MESSAGE,
  WEBWIDGET_SEND_TEXT_MESSAGE,
} from './constants';
import Cards from '../Cards/Cards';
import Carousel from '../Carousel/Carousel';
import { makeSelectDefaultMessageRequest, makeSelectRequestNumber, makeSelectIsTestMode } from '../../services/message/selectors';
import { sendMessageWithoutAction } from '../../services/message/saga';
import { increaseRequestNumber, decreaseRequestNumber } from '../../services/message/actions';
import {
  isIntentKeyword, convertToHyperlink, convertToNextline, convertTo2Nextline,
} from '../../utils';

function isCardLayout(items) {
  return items.length === 1;
}

function convertTextContent(text) {
  let temp = text;
  temp = convertToHyperlink(temp);
  temp = convertToNextline(temp);
  temp = convertTo2Nextline(temp);
  return temp;
}

function updateQuickButtons(actions) {
  const buttonList = [];
  actions.map((x) => buttonList.push({ label: x.title, value: x.title }));
  setQuickButtons(buttonList);
}

function* generateResponse(result) {
  if (result.ok) {
    const { actions, items } = result.data; // shouldEndConversation
    let { text } = result.data;

    if (text) { // Text
      if (!isIntentKeyword(text)) {
        text = convertTextContent(text);
        addResponseMessage(text);
      }
    }

    if (actions) { // Quick reply
      updateQuickButtons(actions);
    }

    if (items) {
      if (isCardLayout(items)) { // Card
        items.map((item) => renderCustomComponent(Cards, {
          title: item.title,
          image: item.image,
          description: item.description,
          buttons: item.actions,
        }));
      } else { // Carousel
        renderCustomComponent(Carousel, { items });
      }
    }
  } else {
    const isTestMode = yield select(makeSelectIsTestMode());
    if (isTestMode) {
      addResponseMessage(`Please try again:\n\n${result.originalError.message || result.problem}`);
    } else {
      addResponseMessage('Please try again');
    }
  }
}

function* triggerLoader() {
  const requestNumber = yield select(makeSelectRequestNumber());
  if (requestNumber === 0) toggleMsgLoader();
}

export function* sendMessage(action) {
  const { data } = action;

  setQuickButtons([]);

  yield call(triggerLoader);
  yield put(increaseRequestNumber());

  const result = yield call(sendMessageWithoutAction, data);
  yield call(generateResponse, result);

  yield put(decreaseRequestNumber());
  yield call(triggerLoader);
}

export function* sendTextMessage(action) {
  const { data } = action;
  const defaultMessageRequest = yield select(makeSelectDefaultMessageRequest());
  const clone = _.cloneDeep(defaultMessageRequest);
  const isChinese = data.toString().match(/[\u3400-\u9FBF]/);
  if (isChinese) {
    clone.message.from.language_code = 'zh';
  }
  clone.message.text = data;
  yield call(sendMessage, { data: clone });
}

export default function* webwidgetSaga() {
  yield all([
    takeEvery(WEBWIDGET_SEND_MESSAGE, sendMessage),
    takeEvery(WEBWIDGET_SEND_TEXT_MESSAGE, sendTextMessage),
  ]);
}
